import { createBrowserHistory } from "history";

export const browserHistory = createBrowserHistory({
  basename: "",
  getUserConfirmation: () => {
    /* Empty callback to block the default browser prompt */
  },
});
